module.exports = __webpack_public_path__ + "h5/img/help-title.4c5de723.png";